import { render, staticRenderFns } from "./MobileCartItem.vue?vue&type=template&id=13a8c280&scoped=true&lang=pug&"
import script from "./MobileCartItem.vue?vue&type=script&lang=js&"
export * from "./MobileCartItem.vue?vue&type=script&lang=js&"
import style0 from "./MobileCartItem.vue?vue&type=style&index=0&id=13a8c280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a8c280",
  null
  
)

component.options.__file = "MobileCartItem.vue"
export default component.exports